export default __webpack_public_path__ + "6cf081ac1291b3b7903f1594f68e6f68.svg";